import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getArticles, deleteArticle, changeStatusArticle } from '../../../../api/article';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';

function getData(articles) {
	let data = [];
	for (let i = 0; i < articles.length; ++i) {
		console.log(articles);
		const elem = {};
		elem.name = articles[i].title;
		elem.createdAt = articles[i].createdAt;
		elem.publication_date = articles[i].publication_date;
		elem.id = articles[i]._id;
		elem.active = articles[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function ArticlesPage() {
	const [data, setData] = useState([]);
	const [articleId, setArticleId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-article/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role === 'admin' && <>
					<Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setArticleId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{color :'red'}}/>}
						</Button>
					</Tooltip>
					<Tooltip title="Eliminar">
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setArticleId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'name', text: 'Nombre', sort: true },
		{
			dataField: 'publication_date',
			text: 'Fecha de publicación',
			formatter: (value) => dateFormatter(value, true),
			sort: true,
		},
		{
			dataField: 'createdAt',
			text: 'Fecha de creación',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getArticles()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'No se han podido obtener los artículos.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Lista de Artículos'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-article')}>
							Añadir nuevo
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`¿Estás seguro de que quieres ${articleId?.active ? 'desactivar' : 'activar'} este artículo?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusArticle(articleId.id, !articleId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${articleId?.active ? '¡Desactivado!' : '¡Activado!'}`, customMessage: `Artículo ${articleId?.active ? 'desactivado' : 'activado'} correctamente` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `No se ha podido ${articleId?.active ? 'desactivar' : 'activar'} este artículo.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'¿Estás seguro de que quieres eliminar este artículo?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteArticle(articleId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: '¡Eliminado!',
											customMessage: 'Artículo eliminado correctamente.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'No se ha podido eliminar el artículo.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
